import React, { useRef, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { SET_SEARCH_TERM, SET_PAGE_SIZE } from '../enums';
import { fxDataList } from '../selectors/fxRegisterSelector';
import { get, sortBy } from 'lodash';
import { format } from 'date-fns';

const FXRegisterTable = ({ fxData, dispatch, pageSize }) => {

  const loader = useRef(null)
  const [nextPage, setNextPage] = useState(0);

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '20px',
      threshold: 1.0,
    }
    //init an observer and use the (former) load more button as the target
    const observer = new IntersectionObserver(handleObserver, options)
    if (loader.current) {
      observer.observe(loader.current)
    }
  }, [])

  useEffect(() => {
    //watch the page state above (changed by handleObserver)
    //and dispatch an increase in pageSize to load 12 blocks into the list
    const timer = setTimeout(() => {
      if (nextPage > 0) {
        dispatch({ type: SET_PAGE_SIZE });
      }
    }, 300);
    return () => clearTimeout(timer);

  }, [nextPage, dispatch]);

  const handleObserver = (entities) => {
    const target = entities[0]
    if (target.isIntersecting) {
      //Check the target (ref={loader}) is in the viewable area
      //and change the page variable above to a new number thus
      //triggering the useEffect that's watching [page].
      //Using dispatch does work but eslint throws an error so we'll
      //maintain 0 deps for this function and put the dispatch in a useEffect above
      //setNextPage(new Date().getTime());
    }
  }

  const loadMore = () => {
    //dispatch({ type: SET_PAGE_SIZE });
    setNextPage(new Date().getTime());
  }

  const loadMoreStyle = () => {
    if (pageSize <= fxData.length) {
      return {
        cursor: 'pointer'
      }
    } else {
      return {
        opacity: '0.4'
      }
    }
  }

  return (
    <>
      <input type="text" placeholder='Search market participant names (minimum 3 characters)' onChange={(e) => dispatch({ type: SET_SEARCH_TERM, obj: e.target.value })} />
      <table id="fx-register-table">
        <thead>
          <tr>
            <th>Market participant name</th>
            <th style={{width: '15%'}}>Date of admission to the CLS public register</th>
            <th style={{width: '15%'}}>Date of statement</th>
            <th>Market participant type</th>
            <th>Statement of commitment</th>
            <th>Disclosure cover sheet</th>
          </tr>
        </thead>
        <tbody>
          {sortBy(fxData, (sb) => sb.participant_name.toLowerCase()).map((e, index) => {
            return (
              <tr key={index}>
                <td data-title="Market participant name">{e.participant_name}</td>
                <td data-title="Date of admission to the CLS public register">{format(new Date(e.date_admission), 'd MMMM yyyy')}</td>
                <td data-title="Date of statement">{format(new Date(e.date_signing), 'd MMMM yyyy')}</td>
                <td data-title="Market participant type">{e.participant_type}</td>
                <td data-title="Statement of commitment">
                  <a style={{textDecoration: 'none'}} href={e.statement_url} target="_blank" rel="noreferrer">Download</a>
                </td>
                <td className={get(e, 'disclosure_cover_sheet', '').length === 0 ? 'hidden': ''} style={{textDecoration: 'none'}} data-title="Disclosure cover sheet">
                  {get(e, 'disclosure_cover_sheet', '').length > 0 && <a href={e.disclosure_cover_sheet} target="_blank" rel="noreferrer">Download</a>}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
      <div className="flex justify-center" style={loadMoreStyle()} onClick={loadMore}>
        <div className="flex items-center text-copper text-18px font-helvetica-neue-bold">
          <div>Load more</div>
          <div><i className="fas fa-chevron-down px-2"></i></div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    fxData: fxDataList(state),
    pageSize: state.pageSize
  }
}

export default connect(mapStateToProps)(FXRegisterTable)